
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/use-auth";

export function useAdminStatus() {
  const [isAdmin, setIsAdmin] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(true);
  const { user, isAuthenticated } = useAuth();

  // ID de l'administrateur en dur pour contourner les problèmes RLS
  const hardcodedAdminEmails = [
    "alexiscarlenockson98@gmail.com",
    "carlenocksonalexis1998@gmail.com"
  ];

  useEffect(() => {
    const checkAdminStatus = async () => {
      try {
        setIsLoading(true);
        
        if (!isAuthenticated || !user) {
          setIsAdmin(false);
          setIsLoading(false);
          return;
        }

        console.log("Checking admin status for user:", user.email, "ID:", user.id);

        // Vérification directe par email
        if (user.email && hardcodedAdminEmails.includes(user.email.toLowerCase())) {
          console.log("User is admin by email:", user.email);
          setIsAdmin(true);
          setIsLoading(false);
          return;
        }
        
        // Fallback à la vérification normale pour les autres utilisateurs
        try {
          const { data, error } = await supabase
            .from('user_roles')
            .select('*')
            .eq('user_id', user.id)
            .eq('role', 'admin')
            .maybeSingle();
          
          if (error) {
            console.warn('Error checking admin status in user_roles:', error);
            setIsAdmin(false);
          } else {
            const isAdminByRole = !!data;
            console.log("Admin status by role:", isAdminByRole);
            setIsAdmin(isAdminByRole);
          }
        } catch (innerError) {
          console.warn('Fallback method also failed:', innerError);
          setIsAdmin(false);
        }
      } catch (error) {
        console.error('Erreur de vérification du statut admin', error);
        setIsAdmin(false);
      } finally {
        setIsLoading(false);
      }
    };

    checkAdminStatus();
  }, [isAuthenticated, user]);

  // Log pour debug
  useEffect(() => {
    if (!isLoading) {
      console.log("Final admin status:", isAdmin, "for user:", user?.email);
    }
  }, [isAdmin, isLoading, user?.email]);

  return { isAdmin, isLoading };
}
